import React from 'react';
import { PagePlaceholder } from '../../components/Container';

export default () => <PagePlaceholder />;
